import React from 'react'
import Select from './Select'

const Randomizer = () => {
  return (
    <div>
      <h2>
        Randomizer
        </h2>
        <Select/>
    </div>
  )
}

export default Randomizer